module.exports = __webpack_public_path__ + "static/media/7 placeorder.501aad39.png";